import { Component, inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { NEVER } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import {
  InfoportalFoldersClientProvider,
  IReceiptFolderCreateCommand,
  ReceiptFolderCreateCommand,
  ReceiptFolderLookupDto,
  ValidationResult,
} from "src/app/web-api/web-api";
import {
  CstFormBuilder,
  CstFormGroup,
} from "src/app/_uncategorised_models_services/cst-form-group";

export interface IInfoportalApiReceiptFolderCreateDialogData {
  collectionNo: string;
  receiptNo: string;
}

@Component({
  templateUrl: "./receipt-folder-create-dialog.component.html",
  styleUrls: ["./receipt-folder-create-dialog.component.scss"],
  standalone: false,
  host: { "data-dialog-unique": "receipt-folder-create-dialog" }, // fixes https://v21.angular.dev/errors/NG0912
})
export class InfoportalApiReceiptFolderCreateDialogComponent extends CstResponsivePopupComponentBase<
  IInfoportalApiReceiptFolderCreateDialogData,
  ReceiptFolderLookupDto
> {
  private _client = inject(InfoportalFoldersClientProvider);

  public form: CstFormGroup<IReceiptFolderCreateCommand>;
  public loading = false;

  constructor() {
    const fb = inject(CstFormBuilder);

    super();

    this.form = fb.group<IReceiptFolderCreateCommand>({
      collectionNo: new FormControl(null, [
        Validators.required,
        Validators.maxLength(24),
      ]),
      receiptNo: new FormControl(null, Validators.maxLength(24)),
      label: new FormControl(null, [
        Validators.required,
        Validators.maxLength(75),
      ]),
      description: new FormControl(null, Validators.maxLength(2000)),
      tagIDs: new FormControl([]),
    });
  }

  onInitialised() {
    this.form.patchValue(this.data);
  }

  public canAccept() {
    return this.form.valid;
  }
  public onAccept() {
    if (!this.canAccept()) {
      return;
    }
    this.loading = true;
    this._client
      .receiptFolderCreate(new ReceiptFolderCreateCommand(this.form.value))
      .pipe(
        finalize(() => (this.loading = false)),
        catchError((error) => {
          if (error instanceof ValidationResult) {
            FormControlBase.ApplyValidationResultToForm(this.form, error);
            return NEVER;
          }
          console.error(error);
          return NEVER;
        }),
      )
      .subscribe((result) => this.close(result));
  }

  public onCancel() {
    this.close();
  }
}
